module.exports = __webpack_public_path__ + "static/media/platform.f4ae08ef.png";